import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const bankAccountDataForm: Form<Client> = {
  key: 'bankAccountData',
  title: 'Bankverbindung',
  fields: [
    {
      key: 'iban',
      label: 'IBAN',
      fieldTypes: 'text',
      xsWidth: 4,
    },
    {
      key: 'bic',
      label: 'BIC',
      fieldTypes: 'text',
      xsWidth: 4,
    },
    {
      key: 'bank',
      label: 'Bank',
      fieldTypes: 'text',
      xsWidth: 4,
    },
    {
      key: 'taxIdentificationNumber',
      label: 'Steuer-ID',
      fieldTypes: 'text',
      xsWidth: 8,
    },
    {
      key: 'fundingNotice',
      label: 'Weitere Infos',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default bankAccountDataForm;
